import {
    DisassociateBusinessUnitModel,
    DisassociateBusinessUnitsModal,
    EmployeeNodeModel,
} from '../../models';

export const DISASSOCIATE_BUSINESS_UNITS_MODAL_EMPTY: DisassociateBusinessUnitsModal =
    {
        startDate: '',
        endDate: '',
        employee: {} as EmployeeNodeModel[],
        listToDelete: {} as DisassociateBusinessUnitModel[],
    };
